'use strict';

$(function() {
    window.docready = true;

    checkReady();
});


window.initMasonry = function (e) {
    console.log('init masonry');
    var $rows = $('.js-layout-raster');
    $.each($rows, function(index, item) {
        var rowWidth = $(item).width();
        var colWidth = $('[class*="col-"]', item).width();
        var prop = Math.round(rowWidth / colWidth);
        if (prop > $('[class*="col-"]', $(item)).length) {
            prop = $('[class*="col-"]', $(item)).length;
        }
        var $items = $('[class*="col-"]:nth-child(' + prop + 'n)', $(item));

        if (prop > 1) {
            $.each($items, function(colIndex, colItem) {
                var y = 0;
                var $colItem = $(colItem);
                var highestContent = $('.article-content', $colItem).outerHeight();
                var highestBox = $('.article-metabox', $colItem).outerHeight();
                var allItems = [];
                allItems.push($colItem);

                for (var i = prop - 1; i > 0; i--) {
                    var hContent = 0;
                    var hBox = 0;

                    $colItem = $colItem.prev();
                    hContent = $('.article-content', $colItem).outerHeight();
                    hBox = $('.article-metabox', $colItem).outerHeight();
                    allItems.push($colItem);

                    if (hContent > highestContent) {
                        highestContent = hContent;
                    }
                    if (hBox > highestBox) {
                        highestBox = hBox;
                    }

                    y++;
                    if (y === prop - 1) {
                        $.each(allItems, function(index, item) {
                            $('.article-content', item).css('height', highestContent);
                            $('.article-metabox', item).css('height', highestBox);
                        });
                    }
                }
            });
        }

    });
}



function isMobile() {
    if(Modernizr.matchmedia) {
        if(window.matchMedia("(max-width: 767px)").matches) { return true; }
        else { return false; }
    }
}

function isTablet() {
    if(Modernizr.matchmedia) {
        if(window.matchMedia("(min-width: 768px) and (max-width: 1024px)")) { return true; }
        else { return false; }
    }
}



function countObjectItems(obj) {
    var count = 0;
    for (var item in obj) {
        if (obj.hasOwnProperty(item)) {
           ++count;
        }
    }

    return count;
}
